import panzoom from 'panzoom';
import { _breakP } from './utils.js';
export default class panzoomFunc {
  constructor() {
    this.panzoomFunc();
  }

  panzoomFunc() {
    const $mapElem = document.querySelectorAll('.js-panzoom');

    if ($mapElem.length) {
      $mapElem.forEach(elm => {
        const $onlyMode = elm.parentNode.dataset.mode;

        function zoom() {
          const $plusBtn = elm.nextElementSibling.querySelectorAll('.js-panzoom-in')[0];
          const $minusBtn = elm.nextElementSibling.querySelectorAll('.js-panzoom-out')[0];
          let eventType, initZoom, initPosX, initPosY;
          if (_breakP.SP) {
            eventType = 'touchstart';
            initZoom = Number(elm.dataset.initZoom);
            initPosX = Number(elm.dataset.initPosX);
            initPosY = Number(elm.dataset.initPosY);
          } else {
            eventType = 'click';
            initZoom = 1;
            initPosX = 0;
            initPosY = 0;
          }
          const panzoomMap = panzoom(elm, {
            maxZoom: 3,
            minZoom: 1,
            initialX: initPosX,
            initialY: initPosY,
            initialZoom: initZoom,
            bounds: true,
            boundsPadding: 1,
            beforeWheel: function (e) {
              var shouldIgnore = !e.altKey;
              return shouldIgnore;
            },
          });
          $plusBtn.addEventListener(eventType, () => {
            panzoomMap.smoothZoom(0, 0, 1.5);
          });
          $minusBtn.addEventListener(eventType, () => {
            panzoomMap.smoothZoom(0, 0, 0.5);
          });
        }

        if ($onlyMode === 'pc') {
          if (!_breakP.SP) {
            zoom();
          }
        } else if ($onlyMode === 'sp') {
          if (_breakP.SP) {
            zoom();
          }
        } else if (!$onlyMode) {
          zoom();
        }

      });
    }
  }
}
